// components
import Footer from "./Footer";
import Header from "./Header";

const LayOut = ({ children }) => {
  return (
    <>
    
      {children}
    </>
  );
};

export default LayOut;